module.exports = __webpack_public_path__ + "static/media/logo.243a0057.svg";